module.exports = __webpack_public_path__ + "static/media/imgBusinessProcess.0b52a040.jpg";